import React, { useState, useEffect } from "react";
import mainLogo from "../assets/logo.svg";
// import mobLogo from '../assets/logo-mob.svg';
import LoadingImage from "../assets/Loading.gif";
import Loading from "../Loading";
import HTTP_BASE_URL from "../../constants/HttpConstants";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import mobLogo from "../assets/Kancroo-logo.svg";

const Login = () => {
  const navigate = useNavigate();
  const [mobile, setMobile] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState({});
  const [loadingImage, setLoadingImage] = useState(false);
  const [displayText, setDisplayText] = useState("Login to view your account");

  function pageLoad() {
    // Extract the 'mobile' parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const mobileParam = urlParams.get("mobile");
    // setMobile(mobileParam || ''); // Set mobile or default to an empty string
    if (mobileParam) {
      setDisplayText("Verify your mobile number");
      setMobile(mobileParam);
    } else {
      setDisplayText("Login to view your account");
      setMobile("");
    }
  }

  const toastrOptions = {
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  };

  const otpSentLogin = async (e) => {
    e.preventDefault();
    setLoadingImage(true); // Start loading
    const newErrors = {};

    // Validate OTP field
    const mobileError = validateField("mobile", mobile);
    if (mobileError) newErrors.mobile = mobileError;

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors); // Update errors state
      toast.warning("Please enter a valid mobile number.", { toastrOptions });
      setLoadingImage(false); // Stop loading on validation failure
      return;
    }

    setError({}); // Clear errors
    const fullData = new FormData();
    fullData.append("mobile", mobile);
    try {
      // Simulate API call or OTP logic
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Replace with your API call
      await fetch(HTTP_BASE_URL + "customerlogin", {
        method: "post",
        headers: {
          "access-token": "508b1430-68f0-4b2f-9003-3c2a0eb2a54a",
        },
        body: fullData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.code === 0) {
            toast.success("OTP has been sent successfully!", { toastrOptions });
            setTimeout(() => navigate(`/otp-verify?mobile=${mobile}`), 1500);
          } else if (result.code === 1) {
            toast.error("No user data found.", {
              toastrOptions,
            });
          }
        });
    } catch (error) {
      console.error("Error sending OTP:", error);
    } finally {
      setLoadingImage(false); // Stop loading
    }
  };

  const inputOnchange = (e) => {
    const { name, value } = e.target;
    setMobile(value); // Update phoneNumber state

    // Validate field and update errors
    const errorMessage = validateField(name, value);
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage, // Update only the specific field's error
    }));
  };

  const validateField = (name, value) => {
    let errorMessage = "";
    if (name === "mobile") {
      if (!value) {
        errorMessage = "Please enter a valid mobile number.";
      } else if (!/^[0-9]{10}$/.test(value)) {
        errorMessage = "Mobile number must be exactly 10 digits.";
      }
    }
    return errorMessage;
  };

  useEffect(() => {
    pageLoad();
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Helmet>
        <title> My Account</title>
      </Helmet>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <div className="container-fluid bg-white p-0 relative">
            <span className="navbar-brand d-none d-lg-block">
              <img
                className="logo-image success-logo"
                src={mainLogo}
                alt="Represents our brand's identity and commitment to quality."
                width={166}
                height={166}
                loading="eager"
              />
            </span>
            <div className="container mob-header">
              <nav className="navbar p-lg-0">
                <div className="container-fluid justify-content-center p-0">
                  <div className="navbar-logo d-lg-none">
                    <img
                      className="img-fluid"
                      src={mobLogo}
                      width={82}
                      height={85}
                      loading="eager"
                      alt="Logo for Kancaroo Trusted Car Carriers, featuring a sleek design with a car silhouette and the company name."
                    />
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="container-fluid booking-section login-banner">
            <div className="container">
              <div className="loginModel">
                <div className="loginContent gstModal-content">
                  <p className="mainHeading red text-center">{displayText}</p>
                  <form onSubmit={otpSentLogin} autoComplete="off">
                    <div className="form-col p-0">
                      <label htmlFor="mobile" className="form-label">
                        Mobile Number <span className="req-span">*</span>
                      </label>
                      <input
                        type="number"
                        name="mobile"
                        value={mobile || ""}
                        onChange={inputOnchange}
                        id="mobile"
                        className="form-control"
                      />
                      {error.mobile && (
                        <p className="text-para red">{error.mobile}</p>
                      )}

                      <p className="text-para f-12 pt-2 text-center login-para">
                        By logging in, I agree to terms and privacy policy
                      </p>
                    </div>
                    <div className="pt-lg-4 pt-3 pb-1 otp">
                      <button
                        type="submit"
                        className="submit-btn"
                        disabled={loadingImage}
                      >
                        {loadingImage ? (
                          <>
                            <span className="sub-loading">
                              <img
                                src={LoadingImage}
                                alt="Progress indicator"
                                width={25}
                                height={25}
                                loading="eager"
                              />
                            </span>
                            Get OTP
                          </>
                        ) : (
                          "Get OTP"
                        )}
                      </button>
                    </div>
                  </form>
                   <button className="sub-heading text-center w-100" 
                   onClick={()=>window.open('https://kancaroo.com/', "_blank")}
                   >Go to Kancaroo.com</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
